




import { Vue } from 'vue-property-decorator';

export default class PopupIframe extends Vue {}
